import { writeToClipboard } from 'base/clipboard';
import {
  compileConcept,
  getPrimaryButtonStyling,
} from 'base/styleguide/concept';
import { ConceptState } from 'base/styleguide/model';
import { Button } from 'base/ui/button';
import { ToastQueue } from 'base/ui/toast';
import React from 'react';

const lightest = 'neutral-shade-0';
const darkest = 'neutral-shade-7';
const primary = 'chromatic1-shade-4';

export function CopyStyleGuide({
  concept,
  toastQueue,
}: {
  concept: ConceptState;
  toastQueue: ToastQueue;
}) {
  const copy = React.useCallback(() => {
    const compiled = compileConcept(concept);
    const payload = {
      typeSettings: {
        size: concept.typeSettings.size,
        weight: concept.typeSettings.weight,
        style: concept.typeSettings.style,
      },
      headingFont: '',
      bodyFont: '',
      buttonStyle: concept.uiStyle,
      buttonRadius: concept.uiStyleRadiusOption,
      cardStyle: concept.cardStyle,
      cardRadius: concept.cardStyleRadiusOption,
      mode: concept.theme,
      colors: Array.from(compiled.colorVariables.entries()),
      schemes: compiled.schemes.map((scheme) => {
        const { darkText, darkAlternate } = getPrimaryButtonStyling({
          concept: compiled,
          uiStyle: concept.uiStyle,
        });
        return {
          background: scheme.background,
          foreground: scheme.foreground,
          text: scheme.text,
          border: scheme.border,
          primaryButtonStyle: scheme.alternate.has('primary-button')
            ? {
                isAlternate: true,
                color: darkAlternate ? lightest : darkest,
                backgroundColor: darkAlternate ? darkest : lightest,
              }
            : {
                isAlternate: false,
                color: darkText ? darkest : lightest,
                backgroundColor: primary,
              },
          alternate: Array.from(scheme.alternate),
        };
      }),
    };
    writeToClipboard({
      'text/plain': JSON.stringify(payload, undefined, 2),
    });

    toastQueue.push({
      label: 'Copied to clipboard',
    });
  }, [concept, toastQueue]);
  return (
    <Button
      variant="secondary"
      label="Copy Style Guide for React"
      onClick={copy}
    />
  );
}
